// extracted by mini-css-extract-plugin
module.exports = {"associations":"_a3000f60"};